import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { http } from "src/api/http";
import { QueryParamDict, createQueryString } from "./constants";

export const useGeneralEditableTableAPIFactory = <T>(
  apiRoute: string,
  getQueryPath: string = '',
  getQueryDict: QueryParamDict = {},
  getUseTake: boolean = true,
  updateQueryPath: string = '',
  updateQueryMethod: string = 'POST',
  deleteQueryPath: string = '',
  mutationSuccessCallback?: () => void
) => {
  const [take, setTake] = useState(5);
  if (getUseTake) {
    getQueryDict['take'] = take.toString();
  }

  const { data: apiResponse, isLoading, refetch } = useQuery<T>({
    queryFn: () => http(`${apiRoute}${getQueryPath}${createQueryString(getQueryDict)}`),
    queryKey: [apiRoute, ...Object.values(getQueryDict)],
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });

  const updateDataMutation = useMutation({
    mutationFn: (batchData: any[]) => http(`${apiRoute}${updateQueryPath}`, { method: updateQueryMethod, body: batchData }),
    onSuccess: () => {
      refetch();
      if (mutationSuccessCallback) {
        mutationSuccessCallback();
      }
    },
  });

  const deleteDataMutation = useMutation({
    mutationFn: (id: string) => http(`${apiRoute}${deleteQueryPath}/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      refetch();
      if (mutationSuccessCallback) {
        mutationSuccessCallback();
      }
    },
  });

  const getAllData = () => {
    setTake(9999);
  }

  return {
    apiResponse,
    isLoading,
    updateDataMutation,
    deleteDataMutation,
    getAllData
  };
}
